/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Datetimebeforeaspect9Inputs */

const de__class_datetimebeforeaspect9 = /** @type {(inputs: _Class_Datetimebeforeaspect9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vor Datum`)
};

/**

* @param {_Class_Datetimebeforeaspect9Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_datetimebeforeaspect9 = /** @type {((inputs?: _Class_Datetimebeforeaspect9Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Datetimebeforeaspect9Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_datetimebeforeaspect9(inputs)
});
export { _class_datetimebeforeaspect9 as "_class_DateTimeBEFOREAspect" }